enum Disposition {
    Unknown = 0,
    ReturnToSupplier = 1,
    Park = 2,
}

export default Disposition;
